<script setup>
import { computed } from 'vue'

const props = defineProps({
	title: {
		type: String,
		default: '',
	},
	boxed: {
		type: Boolean,
		default: true,
	},
	destinations: {
		type: Boolean,
		default: false,
	},
	scheduled: {
		type: Boolean,
		default: false,
	},
})

const boxClass = computed(() => {
	if (props.scheduled) return 'bg-surface-2 rounded-lg p-2 flex flex-col gap-y-2'
	if (props.destinations) return 'bg-surface-1 rounded-xl p-2 flex flex-col gap-y-0.5 md:gap-y-1'
	return 'bg-surface-1 rounded-xl p-2 flex flex-col gap-y-1'
})
</script>

<template>
	<div
		class="platform-list mt-5 min-w-0 w-full max-w-full"
		:class="destinations ? 'destinations-platform-list' : ''"
	>
		<h3 v-if="title" class="text-sm font-medium text-surface-8 mb-2">{{ title }}</h3>
		<div v-if="boxed" :class="boxClass">
			<slot />
		</div>
		<template v-else>
			<slot />
		</template>
	</div>
</template>
